import React from "react";
import { ShoppingBag } from "lucide-react";
import { useCart } from "../context/CartContext";

export default function StickyOrderBar() {
  const { count, total, setOpen } = useCart();
  return (
    <div className="fixed bottom-0 inset-x-0 z-40 lg:hidden pointer-events-none">
      <div className="px-4 pb-4 pointer-events-auto">
        <a
          href={count > 0 ? undefined : "#menu"}
          onClick={count > 0 ? () => setOpen(true) : undefined}
          className="flex items-center justify-between w-full bg-[var(--mm-accent)] text-[var(--mm-bg)] px-5 py-4 shadow-2xl"
        >
          <div className="flex items-center gap-3">
            <ShoppingBag size={18} />
            <span className="font-semibold text-sm tracking-[0.18em] uppercase">
              {count > 0 ? `View Order (${count})` : "Order Now"}
            </span>
          </div>
          <span className="font-display italic text-lg">
            {count > 0 ? `$${total.toFixed(2)}` : "View menu →"}
          </span>
        </a>
      </div>
    </div>
  );
}
